const Url = {
    FromProtocol(protocol, url) {
        return `${protocol}//${url}`;
    },
    FromCurrentProtocol(url) {
        return Url.FromProtocol(document.location.protocol, url);
    }
};

export default Url;


// WEBPACK FOOTER //
// ./Statics/scripts/Core/Url/Url.js